import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import ThemeTagRounded from 'assets/components/tag/themes/Theme.Tag.Rounded';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { RefundConfigTemplateAction, useRefundConfigTemplateProvider } from '../RefundConfigTemplate.Hooks';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export default function RefundConfigTemplateList() {
  const { lang } = getLocales();
  const { listApi, pageRouter, permissions } = useRefundConfigTemplateProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.refundConfigTemplates}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th></th>
          <th>{lang.name}</th>
          <th>{lang.cancellationPeriodThresholdDays}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: refundConfigTemplate }) => (
            <tr key={refundConfigTemplate.id}>
              {' '}
              <td>
                {refundConfigTemplate?.isEnabled ? (
                  <Box
                    class={ThemeTagRounded}
                    style={{ color: Theme.Color.success, backgroundColor: Theme.Color.successLight }}
                  >
                    <Icon class="fas-check" />
                    &nbsp;
                    {lang.enabled}
                  </Box>
                ) : (
                  <Box
                    class={ThemeTagRounded}
                    style={{ color: Theme.Color.error, backgroundColor: Theme.Color.errorLight }}
                  >
                    <Icon class="fas-ban" />
                    &nbsp;
                    {lang.disabled}
                  </Box>
                )}
              </td>
              <td>
                <b>{refundConfigTemplate.internalName}</b>
              </td>
              <td>{refundConfigTemplate.cancellationPeriodThresholdDays.toString()}</td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: refundConfigTemplate.id.toString(),
                      action: RefundConfigTemplateAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_REFUNDCONFIGTEMPLATE}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-edit" />}
                    htmlElementProps={{ title: lang.edit }}
                    active
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: refundConfigTemplate.id.toString(),
                      action: RefundConfigTemplateAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_REFUNDCONFIGTEMPLATE}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    htmlElementProps={{ title: lang.delete }}
                    active
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
